const country2Code = require('./constant/country2Code');
const instruments = require('./constant/instruments');
const language = require('./constant/language');
const musicStyle = require('./constant/musicStyle');
const projectStatus = require('./constant/projectStatus');
const recordingSoftware = require('./constant/recordingSoftware');
const taskPriority = require('./constant/taskPriority');
const taskStatus = require('./constant/taskStatus');
const instrumentsList = require('./constant/instrumentsList');
const musicKeyList = require('./constant/musicKeyList');

Object.assign(exports, {
  country2Code,
  instruments,
  language,
  musicStyle,
  projectStatus,
  recordingSoftware,
  taskPriority,
  taskStatus,
  instrumentsList,
  musicKeyList
});